import React, { useState } from 'react';
import styles from './SidebarSection.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import SidebarItem from '../group/SidebarItem';
import { Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';

// Item ativo também nas telas de dentro dele (ex.: a ficha /patients/12 marca Pacientes)
const matchesPath = (pathname, path) => pathname === path || (path && path !== '/' && pathname.startsWith(`${path}/`));

const SidebarSection = ({ title, items, isOpen, icon, disableNavigation = false, allowedRoutes = [] }) => {
    const location = useLocation();
    const activeItem = items.find(item => matchesPath(location.pathname, item.path));
    // Aberta de saída quando a tela atual é dela, para o item marcado ficar à vista
    const [isExpanded, setIsExpanded] = useState(title == "Principal" || Boolean(activeItem));

    const toggleExpand = () => {
        if (isOpen) {
            setIsExpanded(!isExpanded);
        }
    };

    // Verifica se algum item da seção está ativo
    const isSectionActive = Boolean(activeItem);
    // Menu recolhido: a seção mostra o ícone e o nome da tela atual (em Pacientes, não a casa do Início)
    const collapsedIcon = !isOpen && activeItem && activeItem.icon ? activeItem.icon : icon;
    const collapsedTitle = activeItem ? `${title} › ${activeItem.label}` : title;

    const sectionHeader = (
        <>
            <div className={`${styles.sectionIcon} ${isSectionActive ? styles.sectionIconActive : ''}`}>
                {collapsedIcon}
            </div>
            {isOpen && (
                <>
                    <span className={styles.title}>{title}</span>
                    <FontAwesomeIcon 
                        icon={isExpanded ? faChevronDown : faChevronRight} 
                        className={styles.chevron}
                    />
                </>
            )}
        </>
    );

    return (
        <div className={styles.section}>
            {isOpen ? (
                <div className={`${styles.sectionHeader} ${isSectionActive ? styles.sectionHeaderActive : ''}`} onClick={toggleExpand}>
                    {sectionHeader}
                </div>
            ) : (
                <Tooltip title={collapsedTitle} placement="right">
                    <div className={`${styles.sectionHeaderCollapsed} ${isSectionActive ? styles.sectionHeaderActive : ''}`}>
                        {sectionHeader}
                    </div>
                </Tooltip>
            )}
            {isOpen && (
                <div className={`${styles.sectionContent} ${!isExpanded && styles.collapsed}`}>
                    {items.map((item) => (
                        <SidebarItem
                            key={item.path}
                            path={item.path}
                            icon={item.icon}
                            label={item.label}
                            isOpen={isOpen}
                            disableNavigation={disableNavigation && !allowedRoutes.includes(item.path)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SidebarSection;